export default __webpack_public_path__ + "static/media/latest-news-manage-img.eb16c178.png";